<template>
  <v-container>
      <v-form
      ref="entryForm"
      v-model="valid"
      >
      <v-layout row wrap>
        <v-flex d-flex xs12 lg6 child-flex>
            <v-text-field
                v-model="firstName"
                :rules="rules.firstName"
                label="First Name"
                :name="makeid(7)"
                :autocomplete="false"
                required
                outlined
                rounded
                class="input-right"
            ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex d-flex xs12 lg6 child-flex>
            <v-text-field
                v-model="lastName"
                :rules="rules.lastName"
                label="Last Name"
                required
                outlined
                rounded
                :name="makeid(7)"
                :autocomplete="false"
                class="input-left"
            ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12 lg6 child-flex>
            <v-text-field
                v-model="emailInput"
                :rules="rules.emailInput"
                label="Email Address"
                :name="makeid(7)"
                :autocomplete="false"
                required
                outlined
                rounded
                class="input-right"
            ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 lg6 child-flex>
            <v-autocomplete
                v-model="county"
                :items="items"
                :rules="rules.county"
                item-text="name"
                item-value="name"
                label="County"
                non-data-text="Please select a county"
                persistent-hint
                return-object
                single-line
                outlined
                rounded
                class="input-left"
            ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12 child-flex>
          <v-checkbox
            v-model="terms"
            :rules="rules.terms"
            required
            off-icon="radio_button_unchecked"
            on-icon="radio_button_checked"
            color="#4080c2"
            dark
            hide-details
          ></v-checkbox>
           <span class="test">I confirm I am over 18 years old and have read the <router-link to="/privacy" target="_blank">Privacy Notice</router-link> and accept the <router-link to="/terms" target="_blank">Terms and Conditions</router-link></span>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="errorMessage">
        <v-flex d-flex xs12>
          <div class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message" v-html="errorMessage">
                {{errorMessage}}
              </div>
            </div>
          </div>
          
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-captcha class="captcha" sitekey="6LccUsMUAAAAAPHLLa5m8Cnb59AD8PBkptT4MeG6" :loadRecaptchaScript="true" @verify="captchaClick" size="100px" @expired="captcha = false"></v-captcha>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="errors.captcha" class="captcha-errors" justify-center>
        <v-flex d-flex xs2>
          <div class="v-text-field__details">
              <div class="v-messages theme--light error--text shift-right-small">
                <div class="v-messages__wrapper text-center">
                  <div class="v-messages__message red-text" >{{errors.captcha}}</div>
                </div>
              </div>
            </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
          <v-flex d-flex xs12 justify="center">
            <v-btn x-large color="#407FC2" rounded block class="superlarge margin-top hidden-lg-and-up" elevation="0" @click="submitEntry">Go</v-btn>
            <v-btn x-large color="#407FC2" rounded class="superlarge margin-top hidden-md-and-down center" elevation="0" @click="submitEntry"> Go </v-btn>
          </v-flex>
      </v-layout>
    </v-form>
    <v-dialog
      v-model="feedbackDialog"
      max-width="490"
      >
      <v-card color="#fff">
        <v-card-text>
          <h3 v-html="feedbackDialogText" class="text-center red-text padded"></h3>
        </v-card-text>
          
          <v-card-actions class="padded-actions">
            <v-spacer></v-spacer>
              <v-btn
                  color="#407FC2"
                  dark
                  rounded
                  min-width="100"
                  @click="feedbackDialog = false"
              >
                  Ok
              </v-btn>
              <v-spacer></v-spacer>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Entry',
  components: {
    'v-captcha' : VueRecaptcha
  },
  mounted() {
      this.axios.get('/data/uk-counties.json').then( (response) => {
          this.items = response.data
      })
  },
  data: () => ({
    valid: false,
    firstName: '',
    lastName: '',
    emailInput: '',
    emailConfirm: '',
    terms: false,
    captcha: false,
    captchaToken : '',
    errorMessage : false,
    items: [],
    county: '',
    feedbackDialog : false,
    feedbackDialogText : '',
    loading: false,
    errors: {
        captcha: false
    },
    rules: {
        emailInput: [
            v => !!v || 'Email is required',
            v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
        ],
        emailConfirm: [
            v => !!v || 'Email Confirmation is required'
        ],
        terms:[
            v => !!v || 'You must agree to continue!'
        ],
        firstName: [
            v => !!v || 'First Name is required',
            v => v.length > 2 || 'First Name must be more than 2 characters'
        ],
        lastName: [
            v => !!v || 'Last Name is required'
        ],
        county: [
            v => !!v || 'County is required'
        ]
    }
  }),
  methods:{
    submitEntry: function () {
      this.errorMessage = false
      if(!this.captcha) {
        this.errors.captcha = "Please prove you are human"
      }
      if(this.$refs.entryForm.validate() && this.captcha) {
          this.loading = true
          var formData = new FormData();
          var api = '/api/submitEntry'
          formData.append('firstName', this.firstName.trim())
          formData.append('lastName', this.lastName.trim())
          formData.append('county', this.county.name)
          formData.append('email', this.emailInput)
          formData.append('terms', this.terms)
          formData.append('recaptcha', this.captchaToken)
          this.axios.post(api, formData).then((response)=>{
              if(response.data.success) {
                // handle success
                if(response.data.payload.win) {
                  var api = '/api/encrypt'
                  var formData = new FormData()
                  formData.append('inbound', response.data.payload.id)
                  this.axios.post(api, formData).then( (response) => {
                    console.log(response);
                    if(response.data.success) {
                      //this.$router.push('/win/'+response.data.payload.encrypted)
                      this.$router.push('/thanks')
                    }
                  })
                  //this.$router.push('/win/'+response.data.payload.id)
                }else{
                  this.$router.push('/sorry')
                }
              }else{
                // handle errors
                this.feedbackDialogText = response.data.errors[0]                
                this.feedbackDialog = true
              }
          })
          return true;
      }
    },
    captchaClick : function (recaptchaToken) {
      this.captcha = true
      this.errors.captcha = false
      this.captchaToken = recaptchaToken
    },
    makeid : function(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    emailMatchError () {
      if(this.emailConfirm.length>0) {
        return (this.emailInput === this.emailConfirm) ? '' : 'Email must match'
      } 
    }
  }
};
</script>
